<template>
  <div class="full-width-table">
    <sdCards title="Son Siparişler" bodypadding="0px" more>
      <template #button>
        <div class="card-nav">
          <ul>
            <li :class="products === 'today' ? 'active' : 'deactivate'">
              <router-link @click="(e) => handleActiveChangeProducts(e, 'today')" to="#"> {{ $t('common.today') }} </router-link>
            </li>
            <li :class="products === 'week' ? 'active' : 'deactivate'">
              <router-link @click="(e) => handleActiveChangeProducts(e, 'week')" to="#"> {{ $t('common.week') }} </router-link>
            </li>
            <li :class="products === 'month' ? 'active' : 'deactivate'">
              <router-link @click="(e) => handleActiveChangeProducts(e, 'month')" to="#"> {{ $t('common.month') }} </router-link>
            </li>
            <li :class="products === 'year' ? 'active' : 'deactivate'">
              <router-link @click="(e) => handleActiveChangeProducts(e, 'year')" to="#"> {{ $t('common.year') }} </router-link>
            </li>
          </ul>
        </div>
      </template>
      <div class="table-bordered top-seller-table table-recent-orders table-responsive">
        <a-table :columns="sellingColumns" :dataSource="data" :pagination="false" size="small">
            <template #revenue="{ record }">
              <a-space>

                <a-badge :count="record.revenue + '₺'" :number-style="{ backgroundColor: '#52c41a' }" />
              </a-space>
            </template>
        </a-table>
      </div>
    </sdCards>
  </div>
</template>
<script>

import {priceFormat} from '@/utility/helper';
export default {
  data() {
    return {
      products: 'year',
      data: [],
      sellingColumns: [
        {
          title: this.$t('pages.sale-performance.table-app-name'),
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: this.$t('pages.sale-performance.table-price'),
          dataIndex: 'price',
          key: 'price',
        },
        {
          title: this.$t('pages.sale-performance.table-commission'),
          dataIndex: 'commission',
          key: 'commission',
        },
        {
          title: this.$t('pages.sale-performance.table-revenue'),
          dataIndex: 'revenue',
          key: 'revenue',
          slots: { customRender: 'revenue' },
        },
      ],
    };
  },
  methods: {
    handleActiveChangeProducts(event, value) {
      this.products = value;
    },
    getData() {
      this.data = [];
      this.$appAxios.post(this.$endpoints.order_sales_get, {}).then((resp) => {
        if (resp.data.status) {
          var _this = this;
          resp.data.data.forEach(function (item, index) {
            _this.data.push({
              key: index,
              name: item.application,
              price: priceFormat(item.order_total),
              commission: item.order_commission_rate,
              revenue: priceFormat(item.developer_revenue),
            });
          });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
